import { useTranslation } from "react-i18next";
import { buildChipMeta } from "./chipMeta";
import { ProductActions } from "./ProductActions";
import { ProductName } from "./ProductName";
import type { WindowEntryLayoutProps } from "./types";

export function WindowEntryMobile({
    entry,
    preview,
    readonly,
    onRemoveChip,
}: WindowEntryLayoutProps) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col gap-3">
            {preview}
            <div className="flex flex-col gap-3">
                {entry.chips.map((chip) => (
                    <div
                        key={`${chip.category}:${chip.typeId}`}
                        className="flex items-center gap-3"
                    >
                        <ProductName
                            name={chip.productName}
                            meta={buildChipMeta(chip, t)}
                            className="flex-1"
                        />
                        <ProductActions
                            quantity={chip.quantity}
                            price={chip.price}
                            productName={chip.productName}
                            onRemove={
                                readonly === true
                                    ? undefined
                                    : () => onRemoveChip?.(chip)
                            }
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
